<template>
  <div class="white-row row">
    <div class="white-row-body col-12">
      <slot>white row</slot>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$radius: 50px;
.white-row {
  background-color: #ffbe17;
  margin-left: 0;
  .white-row-body {
    background-color: white;
    border-radius: $radius 0 0 $radius;
    min-height: 100px;
  }
}
</style>


<script>
export default {
  name: "white",
  props: {}
};
</script>